<th></th>
<th>
  <a (click)="sortBy('name')">
    <span>{{ "homepage.cards.knowledges.placeholder_name" | translate }}</span>
    <span
      *ngIf="sortValue === 'name' && sortOrder == 'up'; else defaultNameOrder"
    >
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    <ng-template #defaultNameOrder>
      <span>
        <fa-icon
          [icon]="faCaretDown"
          [ngClass]="sortValue === 'name' ? '' : 'deactivate'"
        ></fa-icon>
      </span>
    </ng-template>
  </a>
</th>
<th>
  <a (click)="sortBy('author')">
    <span>{{
      "homepage.cards.knowledges.placeholder_author" | translate
    }}</span>
    <span
      *ngIf="
        sortValue === 'author' && sortOrder == 'up';
        else defaultAuthorOrder
      "
    >
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    <ng-template #defaultAuthorOrder>
      <span>
        <fa-icon
          [icon]="faCaretDown"
          [ngClass]="sortValue === 'author' ? '' : 'deactivate'"
        ></fa-icon>
      </span>
    </ng-template>
  </a>
</th>
<th>
  <a (click)="sortBy('contributors')">
    <span>{{
      "homepage.cards.knowledges.placeholder_contributors" | translate
    }}</span>
    <span
      *ngIf="
        sortValue === 'contributors' && sortOrder == 'up';
        else defaultContributorsOrder
      "
    >
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    <ng-template #defaultContributorsOrder>
      <span>
        <fa-icon
          [icon]="faCaretDown"
          [ngClass]="sortValue === 'contributors' ? '' : 'deactivate'"
        ></fa-icon>
      </span>
    </ng-template>
  </a>
</th>
<th>
  <a (click)="sortBy('knowledges')">
    <span>{{
      "homepage.cards.knowledges.placeholder_entry_number" | translate
    }}</span>
    <span
      *ngIf="
        sortValue === 'knowledges' && sortOrder == 'up';
        else defaultKnowledgesOrder
      "
    >
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    <ng-template #defaultKnowledgesOrder>
      <span>
        <fa-icon
          [icon]="faCaretDown"
          [ngClass]="sortValue === 'knowledges' ? '' : 'deactivate'"
        ></fa-icon>
      </span>
    </ng-template>
  </a>
</th>
